/**
 * @owner @Appboy/reporting
 */

export const campaignCanvasConsumption =
  "/analytics_dashboard/:app_group_id/campaign_canvas_credit_consumption_detail_data";
